<template>
    <Dropdown class="RPProfile">
        <template v-slot="{open, toggleDropdown}">
            <button
                class="RPProfile__button"
                @click="toggleDropdown"
            >
                <template v-if="showWelcome">
                    <span
                        :class="[
                            'RPProfile__text',
                            open && 'RPProfile__text--active'
                        ]"
                    >
                        Hi, <strong>{{ userProfile.first_name }}</strong>
                    </span>

                    <StreamlineIcon
                        :icon="open ? ArrowUp1 : ArrowDown1"
                        :stroke="open ? primary : textGrey"
                        :fill="open ? primary : textGrey"
                        :size="10"
                    />
                </template>
                <RPUserAvatar
                    v-else
                    :avatar="userProfile.profile_image"
                />
            </button>
        </template>
        <template v-slot:dropdown="{close}">
            <ProfileDropdown
                :user-profile="userProfile"
                @nav-to-profile="emit('nav-to-profile', close)"
                @sign-out="e => emit('sign-out', close)"
            />
        </template>
    </Dropdown>
</template>

<script>
import Dropdown from 'components/Basic/Elements/Dropdown.vue';
import {ArrowUp1, ArrowDown1} from "@reviewpush/streamline-bold/lib/arrows-diagrams/Arrows";
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {textGrey, primary} from 'style/_colors.scss';
import has from 'lodash/has';
import RPUserAvatar from '@/components/Basic/Misc/RPUserAvatar.vue';
import ProfileDropdown  from './ProfileDropdown.vue';

const userValidation = (user) => {
    return has(user, 'first_name')
  && has(user, 'email')
  && has(user, 'role_name')
  && has(user, 'profile_image');
};
export default {
    name: "RPProfile",
    components: {
        Dropdown,
        ProfileDropdown,
        StreamlineIcon,
        RPUserAvatar
    },
    props: {
        userProfile: {
            type: Object,
            required: true,
            validation: userValidation
        },
    },
    data() {
        return {
            size: 1000,

            ArrowUp1,
            ArrowDown1,
            textGrey,
            primary
        };
    },
    computed: {
        showWelcome(){
            return this.size >= 657;
        }
    },
    destroyed(){
        document.removeEventListener('resize', this.resize);
    },
    mounted() {
        window.addEventListener('resize', this.resize);
        this.resize();
    },
    methods: {
        resize(){
            this.size = Math.min(window.innerWidth, window.screen.width);
        },
        emit(action, closeDropdown){
            closeDropdown();
            this.$emit(action);
        }
    }
};
</script>

<style lang="scss">
.RPProfile {
    vertical-align: top;
    margin-right: 1rem;
    display: inline-block;
    height: 100%;
    &__button{
        height: 100%;
        white-space: nowrap;
    }
    &__text {
        color: $text-dark;
        margin-right: 0.5rem;
        &--active {
            color: $primary
        }
    }
}
</style>